import type { ExamTypeConfig } from '@examflow/core';
import { registerExamQuestionTypes } from '@examflow/core';
import { TOEFL_SECTIONS } from './sections';
import { toeflScoringRules } from './scoring';
import { TOEFL_QUESTION_TYPE_DEFINITIONS } from './questionTypes';

/**
 * TOEFL 考试完整配置
 */
export const toeflExamConfig: ExamTypeConfig = {
  id: 'toefl',
  name: 'TOEFL (Test of English as a Foreign Language)',
  description: '托福考试 - 美国教育考试服务中心主办，主要用于美国留学',
  languageId: 'english',
  questionTypeDefinitions: TOEFL_QUESTION_TYPE_DEFINITIONS,
  sections: TOEFL_SECTIONS,
  scoringRules: toeflScoringRules,
};

registerExamQuestionTypes('toefl', Object.values(TOEFL_QUESTION_TYPE_DEFINITIONS));

export * from './types';
export * from './levels';
export * from './sections';
export * from './scoring';
export * from './intro';
export * from './questionTypes';
